import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button } from '@/components/ui/Button';
import { useCurrentAdmin } from '@/hooks/useAuth';
import { useLogout } from '@/api/queries/auth';
import { useHealth } from '@/api/queries/system';
import { useUIStore } from '@/store/ui';
import { paths } from '@/routes/paths';
import styles from './TopBar.module.css';

export function TopBar() {
  const admin = useCurrentAdmin();
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const { data: health } = useHealth();
  const logout = useLogout();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout.mutateAsync();
    toast.success('Signed out');
    navigate(paths.login, { replace: true });
  };

  return (
    <header className={styles.bar}>
      <button
        type="button"
        className={styles.iconBtn}
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        ≡
      </button>

      <div className={styles.spacer} />

      <div className={styles.meta}>
        <span className={styles.healthDot} data-state={health?.status ?? 'unknown'} />
        <span className={styles.metaLabel}>
          {health?.status ?? 'health?'}{' '}
          {health?.version && <small>v{health.version}</small>}
        </span>
      </div>

      <div className={styles.user}>
        <div className={styles.avatar}>
          {(admin?.display_name ?? admin?.email ?? '?').slice(0, 1).toUpperCase()}
        </div>
        <div className={styles.userText}>
          <strong>{admin?.display_name ?? admin?.email}</strong>
          <small>{admin?.role}</small>
        </div>
      </div>

      <Button variant="ghost" size="sm" onClick={onLogout} loading={logout.isPending}>
        Sign out
      </Button>
    </header>
  );
}
